// extracted by mini-css-extract-plugin
export default {"newProject_container":"NovoUsuario_newProject_container__WgP2q"};